/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Speed } from '@mui/icons-material'

import { useHyperspace } from '@acs-manageability/webrtc-react'

export function Telemetry({ renderLatency }) {
  const [stats, setStats] = useState({
    FPS: 0,
    bandwidth: '',
    localPairConnectionType: 'host',
    roundTripTime: undefined,
  })

  const { getStats } = useHyperspace((state) => ({
    getStats: state.getStats,
  }))

  useEffect(() => {
    const timer = setInterval(() => {
      if (!getStats) {
        return
      }
      getStats()
        .then(({ FPS, bandwidth, localPairConnectionType, roundTripTime }) => {
          let formattedBandwidth = ''
          if (!Number.isNaN(bandwidth)) {
            formattedBandwidth =
              bandwidth > 1024
                ? `${(bandwidth / 1024).toFixed(1)} Mbps`
                : `${bandwidth.toFixed()} Kbps`
          }
          setStats({
            FPS,
            bandwidth: formattedBandwidth,
            localPairConnectionType,
            roundTripTime,
          })
        })
        .catch(() => {
          setStats((oldStats) => ({
            FPS: 0,
            bandwidth: '0 Kbps',
            localPairConnectionType: oldStats.localPairConnectionType,
            roundTripTime: undefined,
          }))
        })
    }, 1000)

    return () => clearInterval(timer)
  }, [getStats])

  const renderTelemetry = () => {
    if (stats.bandwidth && stats.FPS) {
      return `${stats.bandwidth} | ${stats.FPS} fps`
    }
    if (stats.bandwidth && !stats.FPS) {
      return `${stats.bandwidth} | 1 fps`
    }
    if (!stats.bandwidth && stats.FPS) {
      return `${stats.FPS} fps`
    }
    return 'N/A'
  }

  return (
    <>
      <div
        data-testid="Telemetry"
        className="telemetry"
        style={stats.FPS == null && stats.bandwidth == null ? { backgroundColor: '#e5e5e5' } : {}}
        title="Telemetry"
      >
        <Speed />
        {renderTelemetry()}
        {renderLatency && Number.isFinite(stats.roundTripTime) && (
          <> | {Math.trunc(stats.roundTripTime * 1000)} ms</>
        )}
      </div>
      {stats.localPairConnectionType === 'relay' && <label>Relay</label>}
    </>
  )
}
